<div class="map-card" *ngIf="marker" [ngClass]="{'active':marker.card.url, 'has-debug': debug}">
    <div class="picture" *ngIf="hasMedia">
        <finder-picture class="picture-img" [picture]="marker.card.media" [lazyLoad]="false" class="fit"></finder-picture>
    </div>
    <div class="content" [ngClass]="{'no-url': !marker.card.url, 'no-link': !marker.card.url}">
        <div class="card-icon" *ngIf="marker.card.iconObj">
            <finder-font-icon [name]="marker.card.iconObj.icon" size="m"></finder-font-icon>
            <span>{{marker.card.iconObj.name}}</span>
        </div>
        <h2 class="name">{{marker.card.name}}</h2>
        <div class="land-name" *ngIf="marker.card.land">{{marker.card.land}}</div>
        <div class="facet-list" *ngIf="marker.facets">
            <ul>
                <li *ngFor="let facet of marker.facets">
                    {{ facet | join }}
                </li>
            </ul>
        </div>
        <div class="refurbishment-message" *ngIf="marker.card.closedForRefurbishment">{{ marker.card.closedForRefurbishment }}</div>
        <finder-operating-status [data]="marker.card" [facilityId]="marker.id" [labels]="marker.card.waitTimeLabels"></finder-operating-status>
    </div>
    <div class="icon" *ngIf="marker.card.url">&#58124;</div>
    <finder-anchor [href]="marker.card.url" *ngIf="marker.card.url"></finder-anchor>
    <div class="disney-premier-access" *ngIf="marker.card.disneyPremierAccess">
        <finder-premier-access
            [card]="marker.card"
            [fullWidth]="true"
            class="map"
        ></finder-premier-access>
    </div>
    <div class="debug" *ngIf="debug">
        <finder-anchor (click)="showDebug($event)">Debug Info</finder-anchor>
    </div>
</div>
